exports = module.exports = require("../../../../../../develop/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-item[data-v-2b6ad9df]{font-size:18px;text-align:right}.select-box[data-v-2b6ad9df]{margin-left:15px;margin-top:15px;max-width:110px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/css-loader?minimize!/Users/gtirby/develop/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b6ad9df","scoped":true,"hasInlineConfig":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Unpaid.vue
// module id = 368
// module chunks = 0